// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBGyZehYYKxHhUTxA1HgQ5FwlG9qE0GQWU",
  authDomain: "appjingle-pms.firebaseapp.com",
  projectId: "appjingle-pms",
  storageBucket: "appjingle-pms.firebasestorage.app",
  messagingSenderId: "1010201930760",
  appId: "1:1010201930760:web:090fd8cf923c3ab85f35bd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export default app;